/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	PaymentMethodSetupIntentPathParams,
	PaymentMethodSetupIntentRequest,
	PaymentMethodSetupIntentResponse,
} from '../types/PaymentMethodSetupIntent'

/**
 * POST /:organisation/payment-methods/setup-intent
 * @see backend/nexus/modules/Billing/Http/Controllers/PaymentMethodController.php PaymentMethodController::setupIntent
 */
export async function paymentMethodSetupIntent(
	organisation: PaymentMethodSetupIntentPathParams['organisation'],
	data: PaymentMethodSetupIntentRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PaymentMethodSetupIntentResponse>> {
	return axiosInstance.post(`/${organisation}/payment-methods/setup-intent`, data, config)
}
